import { default as _91_46_46_46slug_93GTyQwI2sYFMeta } from "/home/runner/work/ticketco-portal/ticketco-portal/pages/[...slug].vue?macro=true";
import { default as claimItemsoT0Kaq8XuuMeta } from "/home/runner/work/ticketco-portal/ticketco-portal/pages/claimItems.vue?macro=true";
import { default as faqSA0oiAR617Meta } from "/home/runner/work/ticketco-portal/ticketco-portal/pages/faq.vue?macro=true";
import { default as forgotPasswordIMzDxT3fHCMeta } from "/home/runner/work/ticketco-portal/ticketco-portal/pages/forgotPassword.vue?macro=true";
import { default as homevyKLR007pzMeta } from "/home/runner/work/ticketco-portal/ticketco-portal/pages/home.vue?macro=true";
import { default as items8KTm07gcH0Meta } from "/home/runner/work/ticketco-portal/ticketco-portal/pages/items.vue?macro=true";
import { default as loginASnHvgNkNZMeta } from "/home/runner/work/ticketco-portal/ticketco-portal/pages/login.vue?macro=true";
import { default as maintenancef8wq3CagIUMeta } from "/home/runner/work/ticketco-portal/ticketco-portal/pages/maintenance.vue?macro=true";
import { default as myAccountTbRDOCRWIUMeta } from "/home/runner/work/ticketco-portal/ticketco-portal/pages/myAccount.vue?macro=true";
import { default as myQrCodeAoW8SAQq4YMeta } from "/home/runner/work/ticketco-portal/ticketco-portal/pages/myQrCode.vue?macro=true";
import { default as _91id_93DOzaEA6OVXMeta } from "/home/runner/work/ticketco-portal/ticketco-portal/pages/order/[id].vue?macro=true";
import { default as _91id_934VN1t9sqyxMeta } from "/home/runner/work/ticketco-portal/ticketco-portal/pages/order/updatePaymentMethod/[id].vue?macro=true";
import { default as ordersvSIiH55XW3Meta } from "/home/runner/work/ticketco-portal/ticketco-portal/pages/orders.vue?macro=true";
import { default as resetPassworddTCwsoG0zNMeta } from "/home/runner/work/ticketco-portal/ticketco-portal/pages/resetPassword.vue?macro=true";
import { default as transferCompletebyzo3ypxlBMeta } from "/home/runner/work/ticketco-portal/ticketco-portal/pages/transferComplete.vue?macro=true";
import { default as transferItems5dHgMNzA7LMeta } from "/home/runner/work/ticketco-portal/ticketco-portal/pages/transferItems.vue?macro=true";
export default [
  {
    name: "slug___en",
    path: "/:slug(.*)*",
    component: () => import("/home/runner/work/ticketco-portal/ticketco-portal/pages/[...slug].vue")
  },
  {
    name: "claimItems___en",
    path: "/claimItems",
    component: () => import("/home/runner/work/ticketco-portal/ticketco-portal/pages/claimItems.vue")
  },
  {
    name: "faq___en",
    path: "/faq",
    component: () => import("/home/runner/work/ticketco-portal/ticketco-portal/pages/faq.vue")
  },
  {
    name: "forgotPassword___en",
    path: "/forgotPassword",
    component: () => import("/home/runner/work/ticketco-portal/ticketco-portal/pages/forgotPassword.vue")
  },
  {
    name: "home___en",
    path: "/home",
    meta: homevyKLR007pzMeta || {},
    alias: ["/"],
    component: () => import("/home/runner/work/ticketco-portal/ticketco-portal/pages/home.vue")
  },
  {
    name: "items___en",
    path: "/items",
    component: () => import("/home/runner/work/ticketco-portal/ticketco-portal/pages/items.vue")
  },
  {
    name: "login___en",
    path: "/login",
    component: () => import("/home/runner/work/ticketco-portal/ticketco-portal/pages/login.vue")
  },
  {
    name: "maintenance___en",
    path: "/maintenance",
    component: () => import("/home/runner/work/ticketco-portal/ticketco-portal/pages/maintenance.vue")
  },
  {
    name: "myAccount___en",
    path: "/myAccount",
    component: () => import("/home/runner/work/ticketco-portal/ticketco-portal/pages/myAccount.vue")
  },
  {
    name: "myQrCode___en",
    path: "/myQrCode",
    component: () => import("/home/runner/work/ticketco-portal/ticketco-portal/pages/myQrCode.vue")
  },
  {
    name: "order-id___en",
    path: "/order/:id()",
    component: () => import("/home/runner/work/ticketco-portal/ticketco-portal/pages/order/[id].vue")
  },
  {
    name: "order-updatePaymentMethod-id___en",
    path: "/order/updatePaymentMethod/:id()",
    component: () => import("/home/runner/work/ticketco-portal/ticketco-portal/pages/order/updatePaymentMethod/[id].vue")
  },
  {
    name: "orders___en",
    path: "/orders",
    component: () => import("/home/runner/work/ticketco-portal/ticketco-portal/pages/orders.vue")
  },
  {
    name: "resetPassword___en",
    path: "/resetPassword",
    component: () => import("/home/runner/work/ticketco-portal/ticketco-portal/pages/resetPassword.vue")
  },
  {
    name: "transferComplete___en",
    path: "/transferComplete",
    component: () => import("/home/runner/work/ticketco-portal/ticketco-portal/pages/transferComplete.vue")
  },
  {
    name: "transferItems___en",
    path: "/transferItems",
    component: () => import("/home/runner/work/ticketco-portal/ticketco-portal/pages/transferItems.vue")
  }
]